import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import useAuthStore from "../../stores/useAuthStore";
import {
  Container,
  Row,
  Col,
  CardGroup,
  Card,
  CardBody,
  Button,
} from "reactstrap";
import { PacmanLoader } from "react-spinners";
import { FormattedMessage, useIntl } from "react-intl";
import PasswordVisibilityButton from "../../components/Inputs/PasswordVisibilityButton";
import {
  clearLoginEmailPrefill,
  readLoginEmailPrefill,
} from "../../Utilities/loginEmailPrefill";

function Signin() {
  const intl = useIntl();
  const navigate = useNavigate();
  const [prefilledEmail] = useState(readLoginEmailPrefill);
  const [email, setEmail] = useState(prefilledEmail);
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  useEffect(() => {
    clearLoginEmailPrefill();
  }, []);

  const isLoggingIn = useAuthStore((state) => state.isLoggingIn);
  const error = useAuthStore((state) => state.error);
  const signIn = useAuthStore((state) => state.signIn);

  const handleSubmit = (e) => {
    e.preventDefault();
    signIn(email, password);
  };

  const resetPassword = () => {
    navigate("/password/reset");
  };

  if (isLoggingIn) {
    return (
      <div
        className="sweet-loading"
        style={{ position: "fixed", top: "50%", left: "50%" }}
      >
        <PacmanLoader color={"#20a8d8"} loading={true} />
      </div>
    );
  }

  return (
    <div className="form">
      <div className="app flex-row align-items-center">
        <Container>
          <Row className="justify-content-center">
            <Col md="8">
              <CardGroup>
                <Card
                  className="text-white bg-primary py-5 d-md-down-none"
                  style={{ width: 44 + "%" }}
                >
                  <CardBody className="text-center">
                    <div>
                      <img
                        style={{ width: 100 + "%" }}
                        src={"img/LearnWareLoggo.png"}
                        className="img-avatar"
                        alt="LearnWARE logga in"
                      />
                    </div>
                  </CardBody>
                </Card>
                <img
                  src={"img/m_logo.png"}
                  style={{
                    maxWidth: "92%",
                    position: "absolute",
                    top: "-190px",
                    marginLeft: "5px",
                  }}
                  alt="Signin logo"
                  className="d-lg-none img-responsive"
                />
                <Card className="p-4">
                  <CardBody className="d-flex flex-column justify-content-center">
                    <h1>
                      <FormattedMessage id="signin.header" />
                    </h1>
                    <p className="text-muted">
                      <FormattedMessage id="signin.ingress" />
                    </p>
                    <form onSubmit={handleSubmit}>
                      <div className="mb-3">
                        <input
                          autoFocus={!prefilledEmail}
                          name="email"
                          autoComplete="username"
                          className="form-control"
                          type="email"
                          required
                          value={email}
                          onChange={(e) => setEmail(e.target.value)}
                          placeholder={intl.formatMessage({
                            id: "signin.placeholder.username",
                          })}
                        />
                      </div>
                      <div className="position-relative mb-3">
                        <input
                          autoFocus={Boolean(prefilledEmail)}
                          name="password"
                          autoComplete="current-password"
                          className="form-control password-input"
                          type={showPassword ? "text" : "password"}
                          required
                          value={password}
                          onChange={(e) => setPassword(e.target.value)}
                          placeholder={intl.formatMessage({
                            id: "signin.placeholder.password",
                          })}
                        />
                        {password && (
                          <PasswordVisibilityButton
                            visible={showPassword}
                            onToggle={() => setShowPassword((show) => !show)}
                          />
                        )}
                      </div>
                      <Button type="submit" color="primary" className="w-100">
                        <FormattedMessage id="signin.button.login" />
                      </Button>
                      <div className="text-center mt-2">
                        <Button
                          type="button"
                          color="link"
                          onClick={resetPassword}
                        >
                          <FormattedMessage id="signin.button.forgotpassword" />
                        </Button>
                      </div>
                      <Row>
                        <Col>
                          {error && (
                            <div className="info-red">
                              <FormattedMessage id={error} />
                            </div>
                          )}
                        </Col>
                      </Row>
                    </form>
                  </CardBody>
                </Card>
              </CardGroup>
            </Col>
          </Row>
        </Container>
      </div>
    </div>
  );
}

export default Signin;
